import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store'
import storage from '@/utils/storage'
import 'nprogress/nprogress.css' // progress bar style
import cryptoaes from '@/utils/cryptoaes'

Vue.use(VueRouter)

/* Layout */
import Layout from '@/views/layout'

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err) => err)
}

/**
 * 预览代码
 * 重点！！！重点！！！重点！！！
 * guid不能重复，否则控制台报红
 */
export const constantRoutes = [
  // {
  //   path: '/policy',
  //   name: 'Policy',
  //   hidden: true,
  //   redirect: '/policy/privacyPolicy',
  //   meta: {
  //     title: 'Policy',
  //     guid: 'policy'
  //   },
  //   children: [
  //     {
  //       path: '/policy/:type',
  //       name: 'PolicyDetail',
  //       hidden: true,
  //       component: () => import('@/views/policy/index'),
  //       meta: {
  //         title: 'Policy',
  //         guid: 'policyDetail'
  //       }
  //     }
  //   ]
  // },

  {
    path: '/policy/:type',
    name: 'PolicyDetail',
    hidden: true,
    component: () => import('@/views/policy/index'),
    meta: {
      title: 'Policy',
      guid: 'policyDetail'
    }
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login'),
    meta: {
      title: 'Login',
      guid: 'login'
    }
  },
  {
    path: '/authLogin',
    name: 'loauthLogingin',
    hidden: true,
    component: () => import('@/views/authLogin'),
    meta: {
      title: 'authLogin',
      guid: 'authLogin'
    }
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    hidden: true,
    component: () => import('@/views/forgotPassword'),
    meta: {
      title: 'forgotPassword',
      guid: 'forgotPassword'
    }
  },
  {
    path: '/shopifyAuth',
    name: 'shopifyAuth',
    hidden: true,
    component: () => import('@/views/auth/shopifyAuth'),
    meta: {
      title: 'Shopify',
      guid: 'shopifyAuth'
    }
  },
  {
    path: '/paypalCallback',
    name: 'paypalCallback',
    hidden: true,
    component: () => import('@/views/paypalCallback'),
    meta: {
      title: 'Upedge',
      guid: 'paypalCallback'
    }
  },
  {
    path: '/credentials',
    name: 'credentials',
    hidden: true,
    component: () => import('@/views/credentials'),
    meta: {
      title: 'Upedge',
      guid: 'credentials'
    }
  },
  {
    path: '/register',
    name: 'register',
    hidden: true,
    component: () => import('@/views/register'),
    meta: {
      title: 'Register',
      guid: 'register'
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: 'layout',
    meta: { title: 'Layout', guid: 'layout', onlyMode: true, tag: '1' },
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index'),
        meta: {
          title: 'Dashboard',
          icon: 'imgfont iconfont icon-ic_home',
          guid: 'index',
          affix: true,
		  tag: '1'
        }
      },
      {
        path: '/404',
        hidden: true,
        name: '404',
        component: () => import('@/views/static/404'),
        meta: { title: '404 找不到网页', guid: '404' }
      },
      {
        path: '/profile',
        hidden: true,
        name: 'profile',
        component: () => import('@/views/system/user/profile'),
        meta: { title: '个人中心', guid: 'profile' }
      }
    ]
  },
  /** **** 商品 ******/
  {
    path: '/product',
    component: Layout,
    redirect: '/product/myProducts',
    name: 'product',
    meta: { title: 'Product', guid: 'product', icon: 'imgfont iconfont icon-ic_sort', tag: '2' },
    children: [
      {
        path: '/product/winningProducts',
        name: 'winningProducts',
        component: () => import('@/views/product/winningProducts'),
        meta: {
          title: 'Winning Products',
          guid: 'winningProducts',
		  tag: '21'
        }
      },
      {
        path: '/product/privateProducts',
        name: 'privateProducts',
        component: () => import('@/views/product/privateProducts'),
        meta: {
          title: 'Private Products',
          guid: 'privateProducts',
		  tag: '22'
        }
      },
      {
        path: '/product/quotedProducts',
        name: 'quotedProducts',
        component: () => import('@/views/product/quotedProducts'),
        meta: {
          title: 'Quoted Products',
          guid: 'quotedProducts',
		  tag: '23'
        }
      },
      {
        path: '/product/myCart',
        name: 'myCart',
        component: () => import('@/views/product/myCart'),
        meta: {
          title: 'My Cart',
          guid: 'myCart',
		  tag: '24'
        }
      },
      {
        path: '/product/myProducts',
        name: 'myProducts',
        component: () => import('@/views/product/myProducts'),
        meta: {
          title: 'My Products',
          guid: 'myProducts',
		  tag: '25'
        }
      },
      {
        path: '/product/winningProductDetail/:id',
        name: 'winningProductDetail',
        hidden: true,
        component: () => import('@/views/product/productDetail'),
        meta: {
          title: 'Winning Product Detail',
          guid: 'winningProducts'
        }
      },
      {
        path: '/product/privateProductDetail/:id',
        name: 'privateProductDetail',
        hidden: true,
        component: () => import('@/views/product/productDetail'),
        meta: {
          title: 'Private Product Detail',
          guid: 'privateProducts'
        }
      }
    ]
  },
  /** **** 订单 ******/
  {
    path: '/orders',
    component: Layout,
    redirect: '/orders/dropshippingOrders',
    name: 'Orders',
    meta: { title: 'Orders', guid: 'orders', icon: 'imgfont iconfont icon-ic_list', tag: '3' },
    children: [
      {
        path: '/ordres/bulkOrder',
        name: 'BulkOrder',
        hidden: true,
        component: () => import('@/views/orders/bulkOrder'),
        meta: {
          title: 'Bulk Order',
          guid: 'bulkOrder'
        }
      },
      {
        path: '/orders/dropshippingOrders',
        name: 'DropshippingOrders',
        component: () => import('@/views/orders/dropshippingOrders'),
        meta: {
          title: 'Dropshipping Orders',
          guid: 'dropshippingOrders',
		  tag: '31'
        }
      },
      {
        path: '/orders/droppingMerge',
        name: 'droppingMerge',
        component: () => import('@/views/orders/droppingMerge'),
        hidden: true,
        meta: {
          title: 'Merge Orders',
          guid: 'dropshippingOrders'
        }
      },
      {
        path: '/orders/droppingAddorder',
        name: 'DroppingAddorder',
        hidden: true,
        component: () => import('@/views/orders/droppingAddorder'),
        meta: {
          title: 'Add Order',
          guid: 'dropshippingOrders'
        }
      },
      {
        path: '/orders/dropshippingPay',
        name: 'DropshippingPay',
        hidden: true,
        component: () => import('@/views/orders/dropshippingPay'),
        meta: {
          title: 'Pay Order',
          guid: 'dropshippingOrders'
        }
      },
      {
        path: '/orders/deliveryPay',
        name: 'DeliveryPay',
        hidden: true,
        component: () => import('@/views/orders/deliveryPay'),
        meta: {
          title: 'Delivery Pay',
          guid: 'dropshippingOrders'
        }
      },
      {
        path: '/orders/dropshippingSplit',
        name: 'DropshippingSplit',
        hidden: true,
        component: () => import('@/views/orders/dropshippingSplit'),
        meta: {
          title: 'Split Orders',
          guid: 'dropshippingOrders'
        }
      },
      {
        path: '/orders/dropshippingDetail',
        name: 'DropshippingDetail',
        hidden: true,
        component: () => import('@/views/orders/dropshippingDetail'),
        meta: {
          title: 'Dropshipping Detail',
          guid: 'dropshippingOrders'
        }
      },
      // {
      //   path: '/function/tickets',
      //   name: 'Tickets',
      //   component: () => import('@/views/tickets/index'),
      //   meta: {
      //     title: 'Tickets',
      //     guid: 'tickets'
      //   }
      // },
      // {
      //   path: '/function/tickets/:id',
      //   name: 'TicketsDetail',
      //   hidden: true,
      //   component: () => import('@/views/tickets/detail'),
      //   meta: {
      //     title: 'Tickets Detail',
      //     guid: 'tickets'
      //   }
      // },
	  {
	    path: '/function/newTickets',
	    name: 'NewTickets',
	    component: () => import('@/views/newTickets/index'),
	    meta: {
	      title: 'Tickets',
	      guid: 'newTickets',
		  tag: '32'
	    }
	  },
	  {
	    path: '/function/newTickets/:id',
	    name: 'NewTicketsDetail',
	    hidden: true,
	    component: () => import('@/views/newTickets/detail'),
	    meta: {
	      title: 'Tickets Detail',
	      guid: 'newTickets'
	    }
	  },
	  {
	    path: '/function/orderHistory',
	    name: 'orderHistory',
	    component: () => import('@/views/orders/orderHistory'),
	    meta: {
	      title: 'Wholesale Orders ',
	      guid: 'orderHistory',
	  	  tag: '33'
	    }
	  },
    ]
  },
  // 只看负数
  {
    path: '/earlyWarningSku',
    component: Layout,
    redirect: '/earlyWarningSku/index',
    name: 'earlyWarningSku',
    meta: { title: 'EarlyWarningSku', guid: 'earlyWarningSku' },
    hidden: true,
    children: [
      {
        path: '/earlyWarningSku/index',
        name: 'earlyWarningSkuIndex',
        component: () => import('@/views/earlyWarningSku/index'),
        meta: {
          title: 'Only Negative Stock',
          guid: 'earlyWarningSkuIndex'
        }
      }
    ]
  },
  /** **** 库存 ******/
  {
    path: '/inventory',
    component: Layout,
    redirect: '/inventory/PurchaseOrders',
    name: 'Inventory',
    meta: { title: 'Inventory', guid: 'inventory', icon: 'imgfont iconfont icon-ic_chart', tag: '4' },
    children: [
      {
        path: '/inventory/purchaseOrders',
        name: 'PurchaseOrders',
        component: () => import('@/views/inventory/purchaseOrders'),
        meta: {
          title: 'Inventory Orders',
          guid: 'purchaseOrders',
		  tag: '41'
        }
      },
      {
        path: '/inventory/MyInventory',
        name: 'MyInventory',
        component: () => import('@/views/inventory/myInventory'),
        meta: {
          title: 'My Inventory',
          guid: 'myInventory',
		  tag: '42'
        }
      },
	  {
	    path: '/inventory/ServiceList',
	    name: 'Service',
	    component: () => import('@/views/inventory/ServiceList'),
	    meta: {
	      title: 'Service',
	      guid: 'allService',
		  tag: '43'
	    }
	  },
	  {
	    path: '/inventory/AlarmStock',
	    name: 'AlarmStock',
		hidden: true,
	    component: () => import('@/views/inventory/AlarmStock'),
	    meta: {
	      title: 'AlarmStock',
	      guid: 'AlarmStock'
	    }
	  },
	  // {
	  //   path: '/inventory/MyInventoryNew',
	  //   name: 'MyInventoryNew',
	  //   component: () => import('@/views/inventory/myInventoryNew'),
	  //   meta: {
	  //     title: 'My Inventory(new)',
	  //     guid: 'myInventory(new)'
	  //   }
	  // },
	  // {
	  //   path: '/inventory/MyInventoryListNew',
	  //   name: 'MyInventoryListNew',
	  //   hidden: true,
	  //   component: () => import('@/views/inventory/myInventoryListNew'),
	  //   meta: {
	  //     title: 'My Inventory(new)',
	  //     guid: 'myInventory(new)'
	  //   }
	  // },
	  // {
	  //   path: '/inventory/InventoryHistoryNew/:id',
	  //   name: 'InventoryHistoryNew',
	  //   hidden: true,
	  //   component: () => import('@/views/inventory/InventoryHistoryNew'),
	  //   meta: {
	  //     title: 'Inventory Detail(new)',
	  //     guid: 'myInventory(new)'
	  //   }
	  // },
	  {
	    path: '/inventory/MyService/:id',
	    name: 'MyService',
		hidden: true,
	    component: () => import('@/views/inventory/myService'),
	    meta: {
	      title: 'My Service',
	      guid: 'myService'
	    }
	  },
      {
        path: '/inventory/MyInventory/:id',
        name: 'MyInventoryList',
        hidden: true,
        component: () => import('@/views/inventory/myInventoryList'),
        meta: {
          title: 'My Inventory',
          guid: 'myInventory'
        }
      },
      {
        path: '/inventory/InventoryHistory/:id',
        name: 'InventoryHistory',
        hidden: true,
        component: () => import('@/views/inventory/InventoryHistory'),
        meta: {
          title: 'Inventory Detail',
          guid: 'myInventory'
        }
      },
	  {
	    path: '/purchase/index',
	    name: 'Purchase',
	    component: () => import('@/views/purchase/index'),
	    meta: {
	      title: 'Self-Purchase Order',
	      guid: 'purchase',
		  tag: '44'
	    }
	  },
	  {
	    path: '/purchase/purchaseAddorder',
	    name: 'PurchaseAddorder',
	    hidden: true,
	    component: () => import('@/views/purchase/purchaseAddorder'),
	    meta: {
	      title: 'Add Order',
	      guid: 'purchaseAddorder'
	    }
	  },
    ]
  },

  /** **** 店铺 ******/
  {
    path: '/stores',
    component: Layout,
    redirect: '/stores/index',
    name: 'stores',
    meta: { title: 'Stores', guid: 'stores', icon: 'imgfont iconfont icon-ic_store', tag: '5' },
    children: [
      {
        path: '/stores/index',
        name: 'storesIndex',
        component: () => import('@/views/stores/index'),
        meta: {
          title: 'Stores',
          guid: 'storesIndex'
        }
      }
    ]
  },

  /** **** 钱包 ******/
  {
    path: '/wallet',
    component: Layout,
    redirect: '/wallet/finance',
    name: 'My Wallet',
    meta: { title: 'Wallet', guid: 'wallet', icon: 'imgfont iconfont icon-ic_coin', tag: '6' },
    children: [
      {
        path: '/wallet/finance',
        name: 'Finance',
        component: () => import('@/views/wallet/finance'),
        meta: {
          title: 'Finance',
          guid: 'finance',
		  tag: '61'
        }
      },
      
      {
        path: '/wallet/invoice',
        name: 'myInvoice',
        component: () => import('@/views/wallet/myInvoice'),
        meta: {
          title: 'My Invoice',
          guid: 'myInvoice',
		  tag: '62'
        }
      },
	  {
	    path: '/inventory/PurchaseInvoice',
	    name: 'PurchaseInvoice',
	    hidden: true,
	    component: () => import('@/views/function/purchaseInvoice'),
	    meta: {
	      title: 'Purchase Invoice',
	      guid: 'myInvoice'
	    }
	  },
	  {
	    path: '/wallet/financeDetail',
	    name: 'financeDetail',
	    component: () => import('@/views/wallet/financeDetail'),
	    hidden: true,
	    meta: {
	      title: 'Finance Detail',
	      guid: 'myInvoice'
	    }
	  },
	  {
	    path: '/wallet/ticketPaymentDetail',
	    name: 'ticketPaymentDetail',
	    component: () => import('@/views/wallet/ticketPaymentDetail'),
	    hidden: true,
	    meta: {
	      title: 'Ticket Payment Detail',
	      guid: 'myInvoice'
	    }
	  },
      {
        path: '/wallet/InvoiceDetail',
        name: 'InvoiceDetail',
        hidden: true,
        component: () => import('@/views/wallet/invoiceDetail'),
        meta: {
          title: 'Invoice Detail',
          guid: 'myInvoice'
        }
      },
      // Fund Details
      {
        path: '/wallet/FundDetails',
        name: 'FundDetails',
        // hidden: true,
        component: () => import('@/views/wallet/fundDetails'),
        meta: {
          title: 'Fund Details',
          guid: 'fundDetails',
		  tag: '63'
        }
      }
    ]
  },
  {
    path: '/extra',
    component: Layout,
    redirect: '/extra/extraServices',
    name: 'Extra',
    meta: { title: 'Extra Service', guid: 'extra', onlyMode: true, tag: '7' },
    children: [
      {
        path: '/extra/extraServices',
        name: 'extraServices',
        component: () => import('@/views/extraServices/index'),

        meta: {
          title: 'ExtraServices',
          guid: 'extraServices',
          icon: 'iconfont icon-ic_eaeth',
          affix: true
        }
      }
    ]
  },

  /* 加盟 */
  {
    path: '/affiliate',
    component: Layout,
    redirect: '/affiliate/affiliatePage',
    name: 'Affiliate',
    meta: { title: 'Affiliate', guid: 'affiliate', onlyMode: true, tag: '8' },
    children: [
      {
        path: '/affiliate/affiliatePage',
        component: () => import(/* webpackChunkName: "stores-foo" */ '@/views/affiliate/index'),
        name: 'affiliatePage',
        meta: {
          title: 'Affiliates',
          guid: 'affiliatePage',
          icon: 'imgfont iconfont icon-tubiao_lianmeng-lianlianmenghemaishequfuben',
          affix: true,
          noCache: true
        }
      }
    ]
  },

  {
    path: 'function',
    component: Layout,
    name: 'Function',
    hidden: true,
    meta: { title: 'function', guid: 'function' },
    children: [
      {
        path: '/function/orderHistory',
        name: 'OrderHistory',
        component: () => import('@/views/orders/orderHistory'),
        meta: {
          title: 'Orders History',
          guid: 'ordersHistory'
        }
      },
      {
        path: '/function/batchOrderDetail',
        name: 'batchOrderDetail',
        component: () => import('@/views/orders/batchOrderDetail'),
        meta: {
          title: 'Bulk Order',
          guid: 'batchOrderDetail'
        }
      },
      {
        path: '/function/Introduce',
        name: 'Introduce',
        component: () => import('@/views/function/introduce'),
        meta: {
          title: 'Introduce',
          guid: 'extraServices'
        }
      },
      {
        path: '/function/ExtraInvoice',
        name: 'ExtraInvoice',
        component: () => import('@/views/function/extraInvoice'), // 批量订单发票
        meta: {
          title: 'ExtraInvoice',
          guid: 'myInvoice'
        }
      },
      // {
      //   path: '/function/PurchaseInvoice',
      //   name: 'PurchaseInvoice',
      //   component: () => import('@/views/function/purchaseInvoice'), // 库存订单发票
      //   meta: {
      //     title: 'PurchaseInvoice',
      //     guid: 'purchaseInvoice'
      //   }
      // },
      {
        path: '/function/helpeCenter',
        name: 'helpeCenter',
        component: () => import('@/views/function/helpeCenter'), // 库存订单发票
        meta: {
          title: 'helpeCenter',
          guid: 'helpeCenter'
        }
      },
      // {
      //   path: '/function/tickets',
      //   name: 'Tickets',
      //   component: () => import('@/views/tickets/index'),
      //   meta: {
      //     title: 'Tickets',
      //     guid: 'tickets'
      //   }
      // },
      // {
      //   path: '/function/tickets/:id',
      //   name: 'TicketsDetail',
      //   component: () => import('@/views/tickets/detail'),
      //   meta: {
      //     title: 'Tickets Detail',
      //     guid: 'TicketsDetail'
      //   }
      // },
      {
        path: '/function/vip',
        name: 'vip',
        component: () => import('@/views/function/vip'),
        meta: {
          title: 'Vip',
          guid: 'vip'
        }
      },
      {
        path: '/function/notificeList',
        name: 'notificeList',
        component: () => import('@/views/function/notificeList'),
        meta: {
          title: 'Notification',
          guid: 'notificeList'
        }
      },
      {
        path: '/function/notification/:id',
        name: 'NotificationDetail',
        component: () => import('@/views/function/notificationDetail'),
        meta: {
          title: 'notification',
          guid: 'notification'
        }
      },
      {
        path: '/function/salesRank',
        name: 'salesRank',
        component: () => import('@/views/function/salesRank'),
        meta: {
          title: 'Sales Rank',
          guid: 'salesRank'
        }
      },
      {
        path: '/function/salesRank/:id',
        name: 'salesRankDetail',
        component: () => import('@/views/function/salesRankDetail'),
        meta: {
          title: 'Sales Rank',
          guid: 'salesRankDetail'
        }
      }
    ]
  },

  /** **** 设置 ******/
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/index',
    name: 'setting',
    meta: { title: 'Setting', guid: 'setting' },
    hidden: true,
    children: [
      {
        path: '/setting/index',
        name: 'settingIndex',
        component: () => import('@/views/setting/index'),
        meta: {
          title: 'Setting',
          guid: 'settingIndex'
        }
      },
	  {
	    path: '/noRoute/index',
	    name: 'noRouteIndex',
	    component: () => import('@/views/noRoute/index'),
	    meta: {
	      title: 'noRoute',
	      guid: 'noRouteIndex'
	    }
	  }
    ]
  },
  /** **** 设置 ******/

  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new VueRouter({
  routes: constantRoutes,
  mode: 'history', // 去掉url中的#
  base: process.env.VUE_APP_ROUTER_PREFIX
})

export default router

// 白名单 '*.*'全匹配
const whiteList = ['/register', '/login', '/forgotPassword', '/404']
const independentPages = [
  '/credentials', // 后台code 登录
  '/authLogin',
  '/shopifyAuth', // shopify 授权
  '/paypalCallback', // paypal 回调
  '/policy/privacyPolicy',
  '/policy/termsAndConditions',
  '/policy/shippingPolicy',
  '/policy/returnPolicy',
  '/policy/price'

]

// 导航守卫 做权限判断
// eslint-disable-next-line space-before-function-paren
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  // const flag = 1
  // if (flag === 1) {
  //   await store.dispatch('GenerateRoutes')
  //   NProgress.done()
  //   next()
  //   return
  // }
  // 赋值title
  if (to.meta.title) document.title = 'Upedge' // `${to.meta.title} - ${process.env.VUE_APP_TITLE}`

  if (independentPages.indexOf(to.path) !== -1 || independentPages.indexOf('*.*') !== -1) {
    await store.dispatch('GenerateRoutes')
    next()
    NProgress.done()
    return
  }
  // independentPages.indexOf(to.path)

  var tokenStr = storage.getCookie('jdkey')
  // 登录状态或是白名单
  if (tokenStr) {
    let token = tokenStr
    try {
      token = JSON.parse(cryptoaes.decrypt(tokenStr))
    } catch (error) {
      //
    }
    store.dispatch('SetToken', token)
    var hasLogin = store.getters.hasLogin
    // 已登录的状态下直接进主页
    if (['/register', '/login'].includes(to.path)) {
      next({ path: '/', replace: true })
      NProgress.done()
    } else {
      if (hasLogin) {
        next()
      } else {
        store
          .dispatch('GetUserInfo')
          .then(() => {
            store.dispatch('GenerateRoutes').then(() => {
              next({ ...to, replace: true })
              NProgress.done()
            })
          })
          .catch(() => {
            store.dispatch('LogOut').then(() => {
              next({ path: '/login', replace: true })
              NProgress.done()
            })
          })
      }
    }
  } else {
    store.dispatch('GenerateRoutes').then(() => {
      if (whiteList.indexOf(to.path) !== -1 || whiteList.indexOf('*.*') !== -1) {
        // 在免登录白名单，直接进入
        next()
        NProgress.done()
      } else {
        let path = '/login'
        if (to.path === '/index' && to.query.code) {
          path = '/register?code=' + to.query.code
        }
        next({ path, replace: true })
        NProgress.done()
      }
    })
    // 没有token
  }
})

router.afterEach(() => {
  NProgress.done()
})
